<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">员工充值</span>
      </div>
      <div class="right">
        <Button type="primary" @click="modalPay.visible = true">充值</Button>
      </div>
    </div>
    <div class="filter-box">
      <div style="display: flex; align-items: center">
        <span class="subtitle">查询时间:</span>
        <DatePicker
          type="date"
          v-model="staffPage.start"
          placeholder="开始时间"
          style="width: 120px; margin-left: 10px"
        ></DatePicker>
        <span style="margin: 0 5px">至</span>
        <DatePicker
          type="date"
          v-model="staffPage.end"
          placeholder="结束时间"
          style="width: 120px"
        ></DatePicker>

        <span class="subtitle" style="margin-left: 12px">自定查找:</span>
        <Input
          style="width: 200px; margin-left: 6px"
          placeholder="关键字查找"
          v-model="staffPage.search"
        />

        <div class="bottom" style="margin: 0 10px">
          <span class="btn-filter" @click="filterData">查询</span>
          <span class="btn" @click="reset">清空</span>
          <Poptip title="导出Excel" placement="right" trigger="hover">
            <span class="btn">导出报表</span>
            <div slot="content">
              <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
                >导出当前页</Button
              >
              <Button type="success" @click="exportData(1)">导出所有页</Button>
            </div>
          </Poptip>
        </div>
      </div>
    </div>

    <Table :data="staffData" :columns="staffColumns" />
    <div class="t-right">
      <Page
        @on-change="staffPageChange"
        @on-page-size-change="staffSizeChange"
        :total="staffTotal"
        show-elevator
        show-sizer
        show-total
      />
    </div>

    <Modal v-model="modalPay.visible" :width="600" title="员工充值">
      <div class="tips" style="margin-bottom: 20px">
        <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
        提示：只能对消费类型为“配额”的员工进行充值操作
      </div>
      <Form :label-width="100">
        <FormItem label="员工名称:">
          <Select style="width: 250px" v-model="modalPay.data.id" filterable multiple>
            <Option v-for="item in modalPay.staff" :value="item.id" :key="item.id"
              >{{ item.name }}
              <span style="margin-left: 20px; color: #ccc">{{
                item.department_name
              }}</span>
            </Option>
          </Select>
        </FormItem>
        <FormItem label="充值金额:">
          <InputNumber
            :active-change="false"
            style="width: 200px; margin-right: 5px"
            :min="0.01"
            :precision="2"
            v-model="modalPay.data.money"
            placeholder="充值金额"
          ></InputNumber>
          <span v-if="company.pay_type" style="margin-left: 10px"
            >企业余额：{{ company.company_money }}</span
          >
        </FormItem>
        <FormItem label="备注说明:">
          <Input
            v-model="modalPay.data.log"
            style="width: 200px"
            placeholder="输入备注说明"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalPay.visible = false">取消</Button>
        <Button type="primary" v-preventReClick @click="recharge">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
import { verifyDate, monDiff } from "@/libs/util";
export default {
  data() {
    return {
      type: "staff",
      staffData: [],
      staffColumns: [
        {
          key: "create_time",
          title: "充值时间",
          render: (h, data) => {
            return h("span", this.$moment(data.row.create_time));
          },
        },
        { key: "name", title: "员工" },
        { key: "department_name", title: "所属部门" },
        { key: "money", title: "充值金额" },
        { key: "log", title: "充值原因" },
        // {
        //   key: "actions",
        //   title: "操作",
        //   width: 80,
        //   render: (h, data) => {
        //     return h(
        //       "Button",
        //       {
        //         props: { type: "warning", size: "small" },
        //         on: {
        //           click: () => {
        //             this.$Modal.confirm({
        //               title: "重要提醒",
        //               content: "确认删除该充值记录吗？",
        //               onOk: () => {
        //                 this.deleteRechargeLog(data.row.id);
        //               },
        //             });
        //           },
        //         },
        //       },
        //       "删除"
        //     );
        //   },
        // },
      ],
      staffTotal: 0,
      staffPage: {
        p: 0,
        l: 10,
        type: 0,
        start: "",
        end: "",
        search: "",
      },
      date: [],
      modalPay: {
        visible: false,
        staff: [],
        data: {
          id: [],
          money: 0,
          log: "",
        },
      },
    };
  },
  methods: {
    staffSizeChange(l) {
      this.staffPage.l = l;
      this.getData();
    },
    staffPageChange(p) {
      this.staffPage.p = p - 1;
      this.getData();
    },
    getData() {
      this.GetRechargeLog(this.staffPage).then((res) => {
        this.staffData = res.data;
        this.staffTotal = res.total;
      });
      this.GetStaff({ p: 0, l: 1000, is_del: 0 }).then((res) => {
        this.modalPay.staff = [];
        res.data.map((item) => {
          if (item.pay_type == 0) {
            this.modalPay.staff.push(item);
          }
        });
      });
    },
    filterData() {
      if (this.staffPage.start && this.staffPage.end) {
        if (verifyDate(this.staffPage.start, this.staffPage.end)) {
          this.$Message.error("开始时间不能大于结束时间");
          return;
        }
        if (monDiff(this.staffPage.start, this.staffPage.end) > 3) {
          //如果时间跨度超过一年就提示
          this.$Message.error("筛选的时间跨度不能超过3个月");
          return;
        }
        this.staffPage.start = this.$moment(this.staffPage.start, "YYYY-MM-DD");
        this.staffPage.end = this.$moment(this.staffPage.end, "YYYY-MM-DD");
      }
      this.GetRechargeLog(this.staffPage).then((res) => {
        this.staffData = res.data;
        this.staffTotal = res.total;
      });
    },

    deleteRechargeLog(id) {
      this.DeleteRechargeLog({ id }).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        res.status && this.getData();
      });
    },
    recharge() {
      let data = this.modalPay.data;
      if (data.id.length === 0) {
        this.$Message.error("未选择员工");
        return;
      } else if (data.money <= 0) {
        this.$Message.error("充值金额必须大于0");
        return;
      } else if (this.company.pay_type == 1 && data.money > this.company.company_money) {
        //预付费
        this.$Message.error("充值金额不能大于企业余额!");
        return;
      } else if (this.company.pay_type == 0 && data.money > 99999) {
        this.$Message.error("充值金额不能大于99999!");
        return;
      }
      this.loading = true;
      this.StaffRecharge({
        ...data,
        pay_type: this.company.pay_type,
      }).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        this.loading = false;
        this.modalPay.visible = false;
        if (res.status) {
          this.modalPay.data.id = [];
          this.staffPage.p = 0;
          this.getData();
        }
      });
    },
    reset() {
      this.staffPage = {
        p: 0,
        l: 10,
        type: 0,
        start: "",
        end: "",
        search: "",
      };
      this.date = [];
      this.filterData();
    },
    exportData(is_all) {
      let title = [],
        key = [],
        columns = this.staffColumns;
      columns.map((item) => {
        let itemKey = item.key;
        title.push(item.title);
        key.push(itemKey);
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "员工充值记录",
      };
      if (is_all) {
        let start, end;
        if (this.date.length > 0) {
          (start = this.$moment(this.staffPage.start, "YYYY-MM-DD")),
            (end = this.$moment(this.staffPage.end, "YYYY-MM-DD"));
        }
        this.GetRechargeLog({
          p: 0,
          l: 200000,
          type: 0,
          start,
          end,
        }).then((res) => {
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.excelData(this.staffData);
        excel.export_array_to_excel(params);
      }
    },
    excelData(data) {
      console.log(data, "result");
      let result = JSON.parse(JSON.stringify(data));
      result.map((item) => {
        item.create_time = this.$moment(item.create_time);
      });
      return result;
    },
    ...mapActions(["GetRechargeLog", "DeleteRechargeLog", "StaffRecharge", "GetStaff"]),
  },
  mounted() {
    this.getData();
  },
  computed: mapGetters({
    company: "company",
  }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
